import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "./context/LanguageContext";
import { CartProvider } from "./context/CartContext";
import ScrollToTop from "./components/ScrollToTop";
import SEOHead from "./components/SEOHead";
import AgeGate from "./components/AgeGate";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CartDrawer from "./components/CartDrawer";
import FloatingCart from "./components/FloatingCart";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import About from "./pages/About";
import RentGinBar from "./pages/RentGinBar";
import Contact from "./pages/Contact";
import Checkout from "./pages/Checkout";

// Visitor tracking component
function VisitorTracker() {
  const location = useLocation();
  
  useEffect(() => {
    // Track page view
    fetch('/api/track.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        page: location.pathname,
        referrer: document.referrer
      })
    }).catch(() => {}); // Silently fail
  }, [location.pathname]);
  
  return null;
}

function App() {
  return (
    <LanguageProvider>
      <CartProvider>
        <div className="App">
          <AgeGate>
            <BrowserRouter>
              <ScrollToTop />
              <SEOHead />
              <VisitorTracker />
              <Header />
              <CartDrawer />
              <FloatingCart />
              <main>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/shop" element={<Shop />} />
                  <Route path="/product/:id" element={<ProductDetail />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/rent-gin-bar" element={<RentGinBar />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/checkout" element={<Checkout />} />
                </Routes>
              </main>
              <Footer />
            </BrowserRouter>
          </AgeGate>
          <Toaster 
            position="top-right"
            toastOptions={{
              style: {
                background: '#111111',
                color: '#F0F0F0',
                border: '1px solid rgba(201, 169, 98, 0.3)'
              }
            }}
          />
        </div>
      </CartProvider>
    </LanguageProvider>
  );
}

export default App;
